"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Success = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const misc_1 = require("../utils/misc");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const style = (0, css_manager_1.registerClass)((theme, sc) => `
	.${sc('value')} {
		font-weight: ${theme.font.weights.bold};
	}
	
	.${sc('spaced-top')} {
		margin-top: ${theme.ratios.l * theme.font.baseSize}px;
	}
	
	.${sc('spaced-bottom')} {
		margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;
	}
`);
const sc = (0, css_manager_1.currySC)(style);
const valueClass = sc('value');
const Success = ({ t, user, managed, isModal, proceed, supportEmail, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null,
        t `Hello`,
        " ",
        user.firstName,
        " ",
        user.lastName,
        "!"),
    react_1.default.createElement("section", { className: style },
        react_1.default.createElement("div", { className: sc('spaced-bottom') },
            t `Thanks for validating`,
            "."),
        react_1.default.createElement("div", null,
            t `You have been successfully registered as a`,
            ":",
            ' ',
            react_1.default.createElement("span", { className: valueClass }, t(user.role)),
            react_1.default.createElement("br", null),
            managed && (react_1.default.createElement(react_1.default.Fragment, null,
                t `as we related you to`,
                ":",
                ' ',
                react_1.default.createElement("span", { className: valueClass },
                    (0, misc_1.emailDomainLabel)(managed),
                    managed.CountryName && ' - ' + (0, misc_1.emailDomainType)(managed))))),
        react_1.default.createElement("div", { className: sc('spaced-top') },
            t `If you think we're wrong please`,
            ' ',
            react_1.default.createElement("a", { href: `mailto:${supportEmail}` }, t `contact us`)),
        react_1.default.createElement("div", { className: (0, css_manager_1.classNames)(theme_1.footer, (0, css_manager_1.subClass)(theme_1.footer, 'centered')) },
            react_1.default.createElement(Button_1.Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: proceed })))));
exports.Success = Success;
//# sourceMappingURL=Success.js.map